<template>
  <div class="content">
    <div class="contentbox">
      <el-tabs   v-model="activeName">
        <el-tab-pane label="待退料" name="0">
          <Issure v-if="activeName==0" :hanleBtn="3"></Issure>
        </el-tab-pane>
        <el-tab-pane label="退料记录" name="1">
          <IssureRecord v-if="activeName==1" :hanleBtn="3"></IssureRecord>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import Issure from './components/issure'
import IssureRecord from './components/issureRecord'
export default {
  name: "dataMember",
  components:{ Issure,IssureRecord },
  data(){
    return{
      activeName:0
    }
  }
}
</script>

<style scoped>
.content{
  width: 100%;
  background: #f3f4f8;
}
.contentbox {
  margin: 10px;
  padding: 10px;
  background-color:#fff;
  position: relative;
}
</style>